'use client'
import { useEffect, useState } from 'react'

/**
 * FRIDGE-805 — the ONE line the homepage personalises. The page stays a single
 * ISR-cached document; after hydration this asks /api/geo/state (edge geo
 * headers, no cookie, no storage) and, only when a US state comes back, swaps
 * the generic label for "Rebates & energy costs in Texas →". Bots, unknown
 * regions and any fetch failure keep the generic label the server rendered.
 */
export function LocalNearYou({ generic }: { generic: string }) {
  const [state, setState] = useState<{ state: string; name: string } | null>(null)
  useEffect(() => {
    let live = true
    fetch('/api/geo/state', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (live && j && typeof j.state === 'string' && typeof j.name === 'string') setState({ state: j.state, name: j.name }) })
      .catch(() => {})
    return () => { live = false }
  }, [])
  if (!state) return <>{generic}</>
  return (
    <>
      Rebates &amp; energy costs in{' '}
      <a href={`/local/${state.state}`} data-geo-state={state.state} style={{ color: '#0469f0', textDecoration: 'underline' }}>{state.name} →</a>
    </>
  )
}
